/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

app.filter('registerFilter', function () {
    return function (item, model) {
        if (model == undefined)
        {
            ret = item
        } else
        {

            ret = []
            search = model.split(" ");

            for (var key in item)
            {
              el = item[key].personalData


                    searchWord = search[0].toLowerCase();
                    name = el.Nachname + " " + el.Vorname + " " + el.Email//+" " + el.email
                    name = name.toLowerCase()
                    if ((name.indexOf(searchWord) > -1) | (el.Vorname.indexOf(searchWord) > -1))
                    {
                        ret.push(item[key])
                    }

            }
        }
        return ret;
    };

});
